import React, {
  Suspense,
  memo,
  useCallback,
  useEffect,
  useEffectEvent,
  useState,
} from 'react';
import { withRouter } from 'utils/router';
import { connect } from 'react-redux';
import { getCropsSelector } from 'modules/crops';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import {
  getFilterDivisionsSelector,
  getFilterSeasonSelector,
  setFilterDivisions,
  setFilterSeasons,
} from 'modules/globalFilters';
import DefaultModal from 'components/common/modals/DefaultModal';
import {
  getNotificationsUnread,
  getUnreadNotificationsSelector,
  readNotification,
  readAllNotification,
} from 'modules/notifications';
import {
  getCurrentUser,
  getCurrentCustomer,
  getCurrentAdvisor,
  setLogout,
  getCurrentUserSelector,
} from 'modules/auth';
import {
  getCurrentAdvisorCustomerSelector,
  setAdvisorCustomerToState,
} from 'modules/currentAdvisorCustomer';
import { resetField } from 'modules/field';
import { env_bayer, env_externalservices, PUBLIC_URL } from 'env.js';
import {
  getUserId,
  getCustomerId,
  getAdvisorId,
  getYears,
  getAdvisorCustomerId,
  cleanLocalStorage,
} from 'utils';
import { setSentryUser } from 'utils/sentry';
import componentLoader from 'utils/componentLoader';
import DivisionsDropdown from 'components/common/DivisionsDropdown';
import Loader from 'components/common/Loader';
import { resetMapFilters } from 'modules/mapFilters';
import { getFieldsSelector } from 'modules/fields';
import { getDivisionsSelector } from 'modules/divisions';
import { getDivisionsGroupsSelector } from 'modules/divisionGroups';
import { getCustomersSelector } from 'modules/customers';

import Notifications from './Notifications';
import Support from './Support';

// TODO: make a logout function. Delete all stored data

const FieldSelectPanel = componentLoader(
  () => import('components/field/FieldInfo/FieldSelectPanel')
);

const showNotificationError = () => {
  import('components/common/antd/message')
    .then(({ message }) => {
      message.error('Ошибка очистки уведомлений', 100);
    })
    .catch(() => undefined);
};

const ConnectedFieldSelectPanel = connect((state) => ({
  fields: getFieldsSelector(state),
  crops: getCropsSelector(state),
  divisions: getDivisionsSelector(state),
  globalFilterSeasons: getFilterSeasonSelector(state),
  globalFilterDivisions: getFilterDivisionsSelector(state),
}))(FieldSelectPanel);

const Header = (props) => {
  const {
    getCurrentUser,
    getCurrentCustomer,
    getCurrentAdvisor,
    getNotificationsUnread,
    currentUser,
    readNotification,
    readAllNotification,
    history,
    customers,
    setAdvisorCustomerToState,
    resetField,
  } = props;
  const [isFieldModalOpen, setFieldModalOpen] = useState(false);
  const [isShowNotification, toggleNotification] = useState(false);

  useEffect(() => {
    getCurrentUser(getUserId());
    const customerId = getCustomerId();
    if (customerId) getCurrentCustomer(customerId);
    const advisorId = getAdvisorId();
    if (advisorId) getCurrentAdvisor(advisorId);
    if (env_bayer !== 'true') getNotificationsUnread();
  }, [
    getCurrentUser,
    getCurrentCustomer,
    getCurrentAdvisor,
    getNotificationsUnread,
  ]);

  // Пользователь Sentry обновляется при смене пользователя
  const syncSentryUser = useEffectEvent(() => {
    if (env_externalservices === 'true') setSentryUser(currentUser);
  });
  useEffect(() => {
    syncSentryUser();
  }, [currentUser?.id]);

  const handleCloseClick = useCallback(
    async (id) => {
      await readNotification(id);
      getNotificationsUnread();
    },
    [readNotification, getNotificationsUnread]
  );

  const handleReadAllNotification = useCallback(async () => {
    try {
      await readAllNotification();
      getNotificationsUnread();
      toggleNotification(false);
    } catch (error) {
      showNotificationError();
    }
  }, [readAllNotification, getNotificationsUnread]);

  const handleNotificationClick = useCallback(
    ({ fieldId, scoutId, customerId, notificationType, scoutPlanId }) => {
      const examplePath = `/customer/${customerId}/fields/${fieldId}/scouts/${scoutId}`;
      const customer = customers.find((c) => c.id === customerId);
      if (notificationType === 4) {
        history.push(`/customer/${customerId}/recommendations`);
        return;
      }
      if (notificationType === 5) {
        history.push({
          pathname: `/customer/${customerId}/scouting/plans`,
          state: { scoutPlanId },
        });
        return;
      }
      if (history.location.pathname === examplePath) return;
      if (customer) {
        setAdvisorCustomerToState(customerId);
        if (
          !history.location.pathname.includes(
            `/customer/${customerId}/fields/${fieldId}/`
          )
        )
          resetField();
      }
      history.push(examplePath);
    },
    [history, customers, setAdvisorCustomerToState, resetField]
  );

  const showDefaultModal = useCallback(() => setFieldModalOpen(true), []);
  const hideDefaultModal = useCallback(() => setFieldModalOpen(false), []);

  const {
    globalFilterSeasons,
    unreadNotifications,
    divisions,
    divisionGroups,
    globalFilterDivisions,
    location,
    customerName,
  } = props;

  const years = getYears();
  const advisorCustomerId = getAdvisorCustomerId();
  const isAdvisorCustomerId = !!advisorCustomerId;
  const isCustomer = !!getCustomerId();
  const isAdvisorAnalyticsPath = location.pathname === '/advisor/analytics';

  return (
    <header className="page__header">
      {env_bayer === 'true' ? (
        <div
          className="logo pull-left"
          onClick={(e) => {
            e.preventDefault();
            history.push('/');
          }}
          role="button"
          tabIndex={0}
        >
          <img src={`${PUBLIC_URL}/icons/quantumterra_logo.svg`} alt="logo" />
        </div>
      ) : (
        <div
          className="logo logo_width pull-left"
          onClick={(e) => {
            e.preventDefault();
            history.push('/');
          }}
          role="button"
          tabIndex={0}
        >
          <img src={`${PUBLIC_URL}/images/agromon_logo_light.svg`} alt="logo" />
        </div>
      )}
      <nav className="pull-right">
        <ul className="nav nav-pills">
          {(isAdvisorCustomerId || isCustomer) &&
          !divisions.isPending &&
          divisions.list.length > 1 ? (
            <li className="header__user">{customerName}</li>
          ) : null}
          {(isAdvisorCustomerId || isCustomer) &&
            !divisions.isPending &&
            !divisionGroups.isPending && (
              <li className="divisions-dropdown__wrapper">
                <DivisionsDropdown
                  divisions={divisions.list}
                  divisionGroups={divisionGroups.list}
                  value={globalFilterDivisions}
                  handleChange={props.setFilterDivisions}
                  className="header__select header__select_no-elepsis"
                />
              </li>
            )}
          {(isAdvisorCustomerId || isCustomer || isAdvisorAnalyticsPath) && (
            <li>
              <DropdownButton
                title={`Сезон ${globalFilterSeasons}`}
                bsPrefix="header__select"
                id="seasons-dropdown"
                variant="none"
              >
                {(years || [])
                  .filter((y) => y != globalFilterSeasons)
                  .map((year) => (
                    <Dropdown.Item
                      eventKey={year}
                      key={year}
                      onClick={() => {
                        props.setFilterSeasons(year);
                        localStorage.setItem('SEASON', year);
                      }}
                    >
                      Сезон {year}
                    </Dropdown.Item>
                  ))}
              </DropdownButton>
            </li>
          )}
          {(isAdvisorCustomerId || isCustomer) && (
            <li className="header__button" onClick={showDefaultModal}>
              К полю &rsaquo;
            </li>
          )}
          {env_bayer !== 'true' && (
            <li style={{ marginLeft: '24px' }}>
              <DropdownButton
                variant="none"
                title={
                  <div>
                    <div className="notification-badge">
                      <i className="fa fa-bell" />
                      <span className="notification-badge__amount">
                        {unreadNotifications.list?.length ?? 0}
                      </span>
                    </div>
                    <span style={{ marginLeft: '8px', fontSize: '16px' }}>
                      Уведомления
                    </span>
                  </div>
                }
                show={isShowNotification}
                onToggle={toggleNotification}
                disabled={!unreadNotifications.list?.length}
                bsPrefix="header__select header__link header__select_no-caret"
                id="notifications-dropdown"
              >
                <Notifications
                  notifications={unreadNotifications.list || []}
                  handleReadAllNotification={handleReadAllNotification}
                  handleNotificationClick={handleNotificationClick}
                  handleCloseClick={handleCloseClick}
                />
              </DropdownButton>
            </li>
          )}
          <li>
            <DropdownButton
              variant="none"
              title={
                <div>
                  <i className="fa fa-question" />
                  <span style={{ marginLeft: '8px', fontSize: '16px' }}>
                    Помощь
                  </span>
                </div>
              }
              bsPrefix="header__select header__link header__select_no-caret"
              id="support-dropdown"
            >
              <Support />
            </DropdownButton>
          </li>
          {Object.keys(currentUser || {}).length && env_bayer !== 'true' ? (
            <li className="header__user">
              {`${currentUser.last_name} ${currentUser.first_name}`}
            </li>
          ) : null}
          {env_bayer !== 'true' && (
            <li>
              <div
                onClick={(e) => {
                  e.preventDefault();
                  cleanLocalStorage();
                  props.setFilterDivisions();
                  props.resetMapFilters();
                  props.setLogout();
                  history.push('/login');
                }}
                className="header__link"
                role="button"
                tabIndex={0}
              >
                <i className="fas fa-sign-out-alt" />
              </div>
            </li>
          )}
        </ul>
      </nav>
      <DefaultModal
        title="Выберите поле для перехода"
        body={
          <Suspense fallback={<Loader />}>
            <ConnectedFieldSelectPanel
              history={history}
              handleClose={hideDefaultModal}
              customerId={advisorCustomerId}
            />
          </Suspense>
        }
        show={isFieldModalOpen}
        close={hideDefaultModal}
      />
    </header>
  );
};

const header = connect(
  (state) => ({
    currentUser: getCurrentUserSelector(state),
    divisions: getDivisionsSelector(state),
    divisionGroups: getDivisionsGroupsSelector(state),
    globalFilterDivisions: getFilterDivisionsSelector(state),
    globalFilterSeasons: getFilterSeasonSelector(state),
    unreadNotifications: getUnreadNotificationsSelector(state),
    customers: getCustomersSelector(state).list,
    customerName: getCurrentAdvisorCustomerSelector(state).item?.name,
  }),
  {
    getCurrentUser,
    getCurrentCustomer,
    getCurrentAdvisor,
    setLogout,
    resetMapFilters,
    setFilterDivisions,
    setFilterSeasons,
    getNotificationsUnread,
    readNotification,
    readAllNotification,
    setAdvisorCustomerToState,
    resetField,
  }
)(memo(Header));

export default withRouter(header);
